import React, { Component } from 'react';
import Header from '../../Layout/Header'
import { Link } from 'react-router-dom'
// import Sidebar from '../Blog/Sidebar'

class WebsiteHosting extends Component {
	render() {
		return (
<div>
				<Header
					seoTitle="Website Hosting"
					title={"website hosting"}
					image={require('./image-3.jpg')}
				/>
				<div className="entry-content page-blog">

				<div className="container-fluid">
                       			<h2 className="outline text-center">
                            			<div className="line"></div>
                            			<div className="title">
                               			   <img
                                    			src={require("./moshi-icon.png")}
                                    			alt="Icon"
                                    			width="48"
                                    			style={{
                                    			marginTop: -18,
                                    			marginBottom: -12,
                                    			marginRight: 12
                                		   }}/>
                               			Website Hosting
                            			</div>
                       			 </h2>
                    		</div>

					
					<div className="container">
						
						<div className="row">
							<div className="col-lg-12">
							
								
								<p>Website hosting refers to where your website is being stored on the world wide web. After investing in a great Moshi Moshi website, you no doubt want to keep it as safe and secure as possible. We back up our hosted sites daily, and keep the last thirty days worth of records in case they’re needed. </p>

								<h4>Hosting your website with Moshi includes: </h4>
								
        <ul class="with-icons">
              <li>Daily backups (available in case of crashes)</li>
              <li>Fast loading times (due to being Australian based)</li>
              <li>Website software updates (important for security)</li>
  <li>Basic website updates and maintenance (inc. fixing minor faults if under 15 mins)
</li>
  <li>Multiple levels of security and client only access (no possibility of external hacking or security threats)</li>
</ul>

<p>
</p> <p>
</p>
<br></br>
<hr></hr>
<h2>Related Services</h2>
<a class="btn" href="https://www.moshi.com.au/whatwedo/website-development">Website Development</a> 
<a class="btn" href="https://www.moshi.com.au/whatwedo/email-newsletter-marketing">Email Newsletter Marketing</a>
<a class="btn" href="https://www.moshi.com.au/whatwedo/domain-address-registration">Domain Address Registration</a>
<a class="btn" href="https://www.moshi.com.au/whatwedo/app-development">App Development</a>	
<a class="btn" href="https://www.moshi.com.au/whatwedo/custom-programmed-systems">Custom Programmed Systems</a>		
		
<a class="btn" href="https://www.moshi.com.au/whatwedo/social-media-management">Social Media Management</a>	

						
							</div>
							{/* <div className="col-lg-4">
								<Sidebar />
							</div> */}
						</div>
<hr></hr>
<br></br>
<p>We consider website hosting to be like a virtual garage, and your website a Ferrari. Parking your Ferrari in a secure, caring, exclusive Australian garage would give you more peace of mind than a Ferrari parked in an offshore garage packed with a thousand other Ferraris. 

</p>
<h3> Treat your website like the Ferrari it is, and ask Moshi about hosting with us today. </h3>
					</div>
				</div>

			</div>
		);
	}
}

export default WebsiteHosting;


// WEBPACK FOOTER //
// ./src/Pages/WhatWeDo/WebsiteHosting.js